import { useSnackbar } from '~/compositions/snackbar'
import { useI18n } from '~/compositions/i18n'
import { useLogger } from '~/compositions/logger'

export default function useClassifiedAction() {
  const snackbar = useSnackbar()
  const { t } = useI18n()
  const logger = useLogger()

  function handleActionError(error: unknown) {
    const errorMessage = (error as any).response?.data?.error

    if (!errorMessage) {
      logger.captureError(error as any)
      snackbar.error(t('something went wrong'))
      return
    }

    snackbar.error(errorMessage)
  }

  return {
    handleActionError
  }
}
